import React from "react";
import styled from "styled-components";
import { desktop, mobile } from "../../theme";

import tvSrc from "./tv.svg";
import tvScreenMaskSrc from "./tv-screen-mask.svg";

const Header = styled("div")({
  position: "relative",
  marginBottom: 16,

  [desktop]: {
    backgroundImage:
      "linear-gradient(90deg, rgba(124, 253, 52, 0.75) 0%, rgba(27, 198, 175, 0.75) 100%)",
    backdropFilter: "blur(11px)",
    borderRadius: 42,
    padding: "30px 50px 50px",
    "::before, ::after": {
      content: "''",
      display: "block",
      background: "#fff",
      width: 75,
      height: 75,
      borderRadius: "50%",
      position: "absolute",
      top: "50%",
    },
    "::before": {
      left: 0,
      transform: "translate(-50%, -50%)",
    },
    "::after": {
      right: 0,
      transform: "translate(50%, -50%)",
    },
  },
  [mobile]: {
    backgroundImage: "linear-gradient(90deg, #7CFD34 0%, #1BC6AF 100%)",
    borderRadius: 15,
    padding: 20,
  },
});

const No = styled("div")({
  textAlign: "center",
  [desktop]: {
    fontSize: 40,
    marginBottom: 10,
  },
  [mobile]: {
    fontSize: 25,
    marginBottom: 30,
  },
});

const Question = styled("h2")({
  fontSize: 40,
  fontWeight: "bold",
  textAlign: "center",
  margin: "0 auto",
  minHeight: "2em",
  [mobile]: {
    fontSize: 25,
  },
});

const Footer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  margin: "0 -8px",
});

const Text = styled("div")({
  textAlign: "center",
  lineHeight: 1.2,
  fontWeight: "normal",
  [desktop]: {
    fontSize: 24,
  },
  [mobile]: {
    fontSize: 20,
  },
});

const Item = styled("div")({
  cursor: "pointer",
  display: "flex",
  margin: "0 8px 16px",
  flexDirection: "column",
  justifyItems: "stretch",
  [Text]: {
    backgroundColor: "#E5FFDF",
    padding: 20,
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [desktop]: {
      borderRadius: 20,
    },
    [mobile]: {
      borderRadius: 15,
    },

    ":hover": {
      backgroundColor: "#85FB67",
    },
  },
  [desktop]: {
    width: `calc(50% - 16px)`,
  },
  [mobile]: {
    width: `calc(100% - 16px)`,
  },
});

export const Parent = styled("div")({
  [desktop]: {
    padding: "40px 40px 80px",
  },
  [mobile]: {
    padding: "24px",
  },
});

const Layout = styled("div")({
  [desktop]: {
    display: "flex",
  },
});

const Content = styled("div")({});

const Picture = styled("div")({
  [desktop]: {
    flexBasis: 360,
    flexShrink: 0,
    marginLeft: 50,
  },
});

const Tv = styled("div")({
  position: "relative",
  "::before": {
    content: "''",
    position: "absolute",
    backgroundImage: `url(${tvSrc})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  "::after": {
    content: "''",
    display: "block",
    paddingTop: "74%",
  },
});

const TvImage = styled("div")({
  position: "absolute",
  // 355.44 x 263.06
  // 24.25
  top: "9.21%",
  // 89.65
  right: "25.22%",
  // 32.48
  bottom: "12.34%",
  // 24.84
  left: "6.98%",
  mask: `url(${tvScreenMaskSrc})`,
  backgroundSize: "cover",
  backgroundPosition: "center center",
  backgroundImage: ({ image }) => `url(${image})`,
});

export const Questions = ({ questions, results, setResults, children }) => {
  const [title, answers, , tvImage] = questions[results.length];

  return (
    <Parent>
      {children}
      <Layout>
        <Content>
          <Header>
            <No>
              {results.length + 1} / {questions.length}
            </No>
            <Question>{title}</Question>
          </Header>
          <Footer>
            {answers.map(($text, key) => (
              <Item
                {...{ key }}
                onClick={() => setResults((state) => [...state, key])}
              >
                <Text>{$text}</Text>
              </Item>
            ))}
          </Footer>
        </Content>
        <Picture>
          {tvImage && (
            <Tv>
              <TvImage image={tvImage} />
            </Tv>
          )}
        </Picture>
      </Layout>
    </Parent>
  );
};
